import Dashboard from './DashboardContainer';

export default Dashboard;
